import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';

import "./App.css"
import Home from './pages/Home'
const App = () => {
  return (
    <div className="container">
    <Home/>
    </div>
  )
}

export default App
